module.exports = __webpack_public_path__ + "img/cashin-hand.4a663c27.svg";